// https://claude.ai/chat/e2efeba3-f22b-419e-bafe-a53ca529112e

// DOM
const lazyLoadElements = document.querySelectorAll('.jg-lazy-load-bg');
const lazyLoadBgClass = 'sg-lazy-load-bg';

// Config
const observerOptions = {
    root: null, // Use the viewport as the root
    rootMargin: '250px', // Start loading before the element enters the viewport
    threshold: 0
};

// State
let hasDom = false;

const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const lazyElement = entry.target;
            lazyElement.classList.add(lazyLoadBgClass);
            // Stop observing the element
            observer.unobserve(lazyElement);
        }
    });
}, observerOptions);

// Start observing lazy load elements
function observeLazyLoadElements() {    
    lazyLoadElements.forEach(element => {
        observer.observe(element);
    });
}

function init() {
    hasDom = lazyLoadElements;
    if ( ! hasDom) return;

    observeLazyLoadElements();
}

export default {
    init
}
  